module.exports = __webpack_public_path__ + "fonts/fa-solid-900.06d5f036.eot";